import { AGENT_SESSION_END_REASONS, AGENT_SESSION_EVENTS } from 'src/constants/power-dialer/power-dialer'
import talk2Api from 'src/plugins/api/api'

const HTTP_CONFLICT = 409

// dialer statuses that mean a call is in progress
const ON_CALL_STATUSES = ['MAKING_CALL', 'ANSWERING_CALL', 'CALL_CONNECTED', 'HANGING_UP_CALL']

// keeps a call longer than the backend idle timeout (30 min) from closing the session
const CALL_HEARTBEAT_MS = 5 * 60 * 1000

// Records the Power Dialer session on api-core for reporting. Fire-and-forget:
// a failed request must never interrupt dialing.
export default {
  data () {
    return {
      // resolves to the recorded session id, or null when the start failed
      agentSessionRequest: null,
      agentSessionCallHeartbeat: null
    }
  },

  methods: {
    // idempotent server-side: after a reload it returns the same open session
    startAgentSession () {
      this.agentSessionRequest = talk2Api.V2.powerDialerAgentSessions.start(Number(this.$route.params.id))
        .then(res => res.data?.data?.id ?? null)
        .catch(() => null)

      return this.agentSessionRequest
    },

    async recordAgentSessionEvent (event) {
      const sessionId = await this.agentSessionRequest

      if (!sessionId) {
        return
      }

      try {
        await talk2Api.V2.powerDialerAgentSessions.recordEvent(sessionId, event)
      } catch (err) {
        if (err?.response?.status !== HTTP_CONFLICT) {
          return
        }

        // the idle timeout closed the session: carry on in a new one
        const newSessionId = await this.startAgentSession()

        if (newSessionId) {
          talk2Api.V2.powerDialerAgentSessions.recordEvent(newSessionId, event).catch(() => {})
        }
      }
    },

    // skipped while the session is ending: End Session sets pause right before ending
    recordAgentSessionPause (isPaused) {
      if (!this.agentSessionRequest || this.reRouteModal) {
        return
      }

      this.recordAgentSessionEvent(isPaused ? AGENT_SESSION_EVENTS.pause : AGENT_SESSION_EVENTS.unpause)
    },

    // a call starting, going on and finishing counts as activity for the idle timeout
    recordAgentSessionCallActivity (status, oldStatus) {
      const wasOnCall = ON_CALL_STATUSES.includes(oldStatus)
      const isOnCall = ON_CALL_STATUSES.includes(status)

      if (wasOnCall === isOnCall) {
        return
      }

      this.recordAgentSessionEvent(AGENT_SESSION_EVENTS.dial)
      this.stopAgentSessionCallHeartbeat()

      if (isOnCall) {
        this.agentSessionCallHeartbeat = setInterval(() => {
          this.recordAgentSessionEvent(AGENT_SESSION_EVENTS.dial)
        }, CALL_HEARTBEAT_MS)
      }
    },

    stopAgentSessionCallHeartbeat () {
      clearInterval(this.agentSessionCallHeartbeat)
      this.agentSessionCallHeartbeat = null
    },

    async endAgentSession (reason = AGENT_SESSION_END_REASONS['ended-by-agent']) {
      const request = this.agentSessionRequest
      this.agentSessionRequest = null
      this.stopAgentSessionCallHeartbeat()

      const sessionId = await request

      if (sessionId) {
        talk2Api.V2.powerDialerAgentSessions.end(sessionId, reason).catch(() => {})
      }
    }
  }
}
